import { filter } from 'rxjs/operators';
import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef } from '@angular/material/dialog';

@Component({
    selector: 'app-asistentes-popup',
    templateUrl: './asistentes-popup.component.html',
    styleUrls: ['./asistentes-popup.component.scss'],
    standalone: false
})
export class AsistentesPopupComponent implements OnInit {
  public empresaId: number;
  public contactList: any;
  public selectedContact:any [];
  isError:boolean=false;
  conactText:string="";
  inc:number=0;

  constructor(
    private dialogRef: MatDialogRef<AsistentesPopupComponent>,
  ) {

   }

  ngOnInit(): void {
  
  }

  public cancel(): void {
    this.dialogRef.close();
  }

  public guadar(): void {
    if(this.selectedContact.length==0)
    {
      this.isError=true;
    }else{
      this.selectedContact.forEach(element => {
        this.inc+=1;
        const result = this.contactList.filter((obj) => {
          return obj.id === element;
        });

        if(this.selectedContact.length==this.inc)
        {
          this.conactText+=result[0].nombre + "("+result[0].cargo+") " 
        }else
        {
          this.conactText+=result[0].nombre + "("+result[0].cargo+"); " 
        }
        
      });
      this.dialogRef.close(this.conactText);
    }
   
  }
}
